import { render, staticRenderFns } from "./LandingAvis.vue?vue&type=template&id=4485bd23&scoped=true"
import script from "./LandingAvis.vue?vue&type=script&lang=js"
export * from "./LandingAvis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4485bd23",
  null
  
)

export default component.exports